import React, { FC } from 'react';
import { type IconV2Props } from '../../IconV2';
import { cn } from '@express-labs/raven-tools';
import s from '../../IconV2.scss';

const opacityMap: OpacityMap = {
  default: '0.4',
  hover: '0.6',
  dark: '0.9',
};
const Sound32: FC<IconV2Props> = ({ icon, chroma, className }) => {
  const chromaType = chroma as string;
  const opacity = opacityMap[chromaType] || '';

  return (
    <svg
      className={cn(s.svg32, `svg-icon--${icon}`, className)}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      data-icon={`${icon}-32`}
    >
      <g
        id="Video-Content"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="UI-Sheet" transform="translate(-112.000000, -471.000000)">
          <g id="Group-4-Copy" transform="translate(86.000000, 471.000000)">
            <g
              id="videoControllerPlay"
              transform="translate(26.000000, 0.000000)"
            >
              <g id="controllerbg(60%)" fill="#000000" fillOpacity={opacity}>
                <ellipse
                  id="Oval"
                  cx="15.5151515"
                  cy="16"
                  rx="15.5151515"
                  ry="16"
                />
              </g>
              <g id="icon" transform="translate(10.000000, 10.000000)">
                <path
                  d="M10.2696696,10.2853978 C11.3489071,9.01477784 12,7.36913865 12,5.57142857 C12,3.80256334 11.3696335,2.18092809 10.3212882,0.918910576"
                  id="Path"
                  stroke="#FFFFFF"
                  strokeWidth="1.5"
                />
                <path
                  d="M8.20716432,8.73759652 C8.96613596,7.90081433 9.42857143,6.79012525 9.42857143,5.57142857 C9.42857143,4.44781144 9.03547727,3.41600637 8.37930972,2.60603413"
                  id="Path"
                  stroke="#FFFFFF"
                  strokeWidth="1.5"
                />
                <path
                  d="M1.97365269,8.1735571 C2.0742515,8.1735571 2.17245509,8.20794106 2.25389222,8.26934097 L6,11.1428571 L6,0 L2.25628743,2.87351617 C2.1748503,2.93491609 2.07664671,2.96930004 1.9760479,2.96930004 L0,2.96930004 L0,8.1735571 L1.97365269,8.1735571 Z"
                  id="Path"
                  fill="#FFFFFF"
                  fillRule="nonzero"
                />
              </g>
            </g>
          </g>
        </g>
      </g>
    </svg>
  );
};

export default Sound32;
